import React, { useState, useEffect, useRef, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import ImputComponent from './../../InputComponent';
import { LanguageFactory } from '../../../factories';
import { useLanguage } from '../../../store/languageContext';
import SearchDebounceBar from '../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../factories/propertySearchs';
import { Button, Card, Table, message } from 'antd';
import { LocalPersistence } from '../../../factories/index';
import { sessionType } from '../../../interfaces/index';
import { getAmenityservices } from './../../../services/amenityservice';
import Loading from '../../Loading';
import './TabpanelDetail.css';
import { sortHelper } from '../../../helpers/misc/sortHelper';
import {
  paginationSize,
  getPaginationSession,
} from '@helpers/misc/setPaginationSize';

interface propsTypes {
  addAndEdit: () => any;
  detailAndedit: (param?: any) => any;
}

interface ChargeType {
  charge?: number | null;
  chargefrequency?: string | null;
  chargeunit?: string | null;
  currency?: string | null;
  type?: string | null;
}
interface ScheduleType {
  charge?: ChargeType[];
  enddate?: string | null;
  operationtime?: {
    dayoftheweek?: string | null;
    endtime?: string | null;
    starttime?: string | null;
  }[];
  scheduleid?: number | null;
  startdate?: string | null;
}

interface SecurityTpye {
  accsecurity?: string | null;
  charge?: string | null;
  currency?: string | null;
  description?: string | null;
  quantity?: string | null;
  securityid?: number | null;
  securitylangid?: number | null;
  type?: string | null;
  typedetail?: string | null;
  uom?: string | null;
}

interface TableSourceTypes {
  amsid: number | null;
  amslangid: number | null;
  avail: string | null;
  category: 'Hotel Amenities';
  distance: string | null;
  id: number | string | null;
  included: string | null;
  key: string | null;
  name: string | null;
  proximity: string | null;
  quantity: string | null;
  schedule: ScheduleType[];
  security: SecurityTpye[];
  tags: string | null;
  type: string | null;
  typedetail: string | null;
}

const TabpanelDetail = (props: propsTypes) => {
  const { language } = useLanguage();
  const lang = new LanguageFactory(language);
  const initialRender = useRef(true);
  const [dataSource, setDataSource] = useState<TableSourceTypes[]>([]);
  const [addLoading, setAddLoading] = useState(false);
  const total = dataSource.length;
  const [searchs, setSearch] = useState<string[]>([]);
  const [data, setData] = useState(dataSource);
  const [paginationData, setPaginationData] = useState<number>(10);

  const columns = [
    {
      title: '',
      key: 'index',
      // @ts-ignore ignoring as there are data issues
      render: (text, record, index) =>
        Number(record?.key) ? Number(record?.key) + 1 : (index += 1),
      width: '40px',
    },
    {
      title: lang.translate(language, 'Amenities_name'),
      dataIndex: 'name',
      key: 'name',
      // @ts-ignore ignoring as there are data issues
      sorter: (a, b) => sortHelper(a, b, 'name'),
      showSorterTooltip: false,
    },
    {
      title: lang.translate(language, 'Amenities_type'),
      dataIndex: 'type',
      key: 'type',
      // @ts-ignore ignoring as there are data issues
      sorter: (a, b) => sortHelper(a, b, 'type'),
      showSorterTooltip: false,
    },
    {
      title: lang.translate(language, 'Amenities_included'),
      dataIndex: 'included',
      key: 'included',
      // @ts-ignore ignoring as there are data issues
      sorter: (a, b) => sortHelper(a, b, 'included'),
      showSorterTooltip: false,
    },
    {
      title: lang.translate(language, 'Amenities_proximity'),
      dataIndex: 'proximity',
      key: 'proximity',
      // @ts-ignore ignoring as there are data issues
      sorter: (a, b) => sortHelper(a, b, 'proximity'),
      showSorterTooltip: false,
    },
    {
      title: lang.translate(language, 'Amenities_typeDetail'),
      dataIndex: 'typedetail',
      key: 'typedetail',
      // @ts-ignore ignoring as there are data issues
      sorter: (a, b) => sortHelper(a, b, 'typedetail'),
      showSorterTooltip: false,
    },
  ];

  const onChangeSearch = (term: string) => {
    setSearchTerm(term);
    onDebounce(term);
  };
  const { searchTerm, setSearchTerm, searchTermDebounced, onDebounce } =
    SearchDebounceBar();
  const recentlySearchs = () => {
    return searchs.map((search, index) => {
      return (
        <span
          key={index}
          onClick={() => recoverSearch(search)}
        >
          &nbsp;{search}
          {searchs.length - 1 === index ? '.' : ','}
        </span>
      );
    });
  };

  const recoverSearch = (search: string) => {
    setSearchTerm(search);
    filterData(search);
    onDebounce(search);
  };

  const saveNewSearch = (term: string) => {
    const stackSearchs = new PropertySearch(searchs);
    setSearch(stackSearchs.add(term));
  };

  const afterDebounce = (term: string) => {
    if (term) {
      saveNewSearch(term);
    }
    filterData(term);
  };

  const filterData = async (query: string) => {
    const filterData = data.filter((item: any) => {
      item.key && delete item.key;
      return (
        JSON.stringify(Object.values(item))
          .toLocaleLowerCase()
          .indexOf(query.toLocaleLowerCase()) > -1
      );
    });
    filterData.forEach((item: any, index: any) => {
      item.key = '' + index;
    });
    setDataSource(filterData);
  };

  const getPaginationData = useCallback(async () => {
    return await getPaginationSession(
      setPaginationData,
      'amenities_and_services'
    );
  }, []);

  //init data
  useEffect(() => {
    const postingData = async () => {
      setAddLoading(true);
      const get_session = new LocalPersistence('session');
      const session: sessionType = await get_session.getSessionPersistence();
      getAmenityservices(session.supplier, session.propertyId)
        .then((res) => {
          const resData =
            res &&
            res.property &&
            res.property.amenityservice &&
            res.property.amenityservice.length > 0
              ? res.property.amenityservice
              : [];
          resData.forEach((item: any, index: number) => {
            item.key = '' + index;
          });
          setDataSource(resData);
          setData(resData);
          setAddLoading(false);
        })
        .catch((err) => {
          message.error({
            content: err.message || err.error[0].message,
          });
          setAddLoading(false);
        });
      await getPaginationData();
    };
    postingData();
  }, []);
  // search functionality
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      afterDebounce(searchTermDebounced);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTermDebounced]);
  return addLoading ? (
    <Loading type="large" />
  ) : (
    <Card>
      <Grid
        container
        spacing={0}
        className="containerSpacing py-0"
      >
        <Grid
          item
          xs={12}
          className="p-0"
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ fontWeight: 'bold' }}> Amenities & Services</div>
            <div>
              <Button
                type="primary"
                className="db-add-btn"
                onClick={() => {
                  props.addAndEdit();
                }}
              >
                Add
              </Button>
            </div>
          </div>
        </Grid>
        <Grid
          item
          xs={4}
          className="pb-0 px-0 my-0"
        >
          <ImputComponent
            className="SearchBar"
            label={'Search'}
            labelShrink={true}
            value={searchTerm}
            onChange={onChangeSearch}
            placeholder={'Search Amenities & Services'}
            endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
          />
          <div className="recentlySearchs">
            <p>
              {lang.translate(language, 'recently_searched')}:{' '}
              {recentlySearchs()}
            </p>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          className="p-0"
        >
          <Table
            columns={columns}
            dataSource={dataSource}
            pagination={{
              size: 'small',
              total,

              showSizeChanger: true,
              showTotal: (total, range) =>
                `Total ${total} items, Current ${range[0]}-${range[1]}`,
              defaultPageSize: paginationData,
              onShowSizeChange: (current, size: number) =>
                paginationSize('pagination', { amenities_and_services: size }),
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  let _record = record;
                  if (!_record.schedule || _record.schedule.length === 0) {
                    let operationtime = [
                      { dayoftheweek: 'Mon', starttime: '', endtime: '' },
                      { dayoftheweek: 'Tue', starttime: '', endtime: '' },
                      { dayoftheweek: 'Wed', starttime: '', endtime: '' },
                      { dayoftheweek: 'Thu', starttime: '', endtime: '' },
                      { dayoftheweek: 'Fri', starttime: '', endtime: '' },
                      { dayoftheweek: 'Sat', starttime: '', endtime: '' },
                      { dayoftheweek: 'Sun', starttime: '', endtime: '' },
                    ];
                    let charge = [{ type: '' }];
                    _record.schedule = [{ operationtime, charge }];
                  }
                  _record.schedule.forEach((item) => {
                    if (!item.operationtime || !item.operationtime.length) {
                      item.operationtime = [
                        { dayoftheweek: 'Mon', starttime: '', endtime: '' },
                        { dayoftheweek: 'Tue', starttime: '', endtime: '' },
                        { dayoftheweek: 'Wed', starttime: '', endtime: '' },
                        { dayoftheweek: 'Thu', starttime: '', endtime: '' },
                        { dayoftheweek: 'Fri', starttime: '', endtime: '' },
                        { dayoftheweek: 'Sat', starttime: '', endtime: '' },
                        { dayoftheweek: 'Sun', starttime: '', endtime: '' },
                      ];
                    }
                    if (!item.charge || !item.charge.length) {
                      item.charge = [{ type: '' }];
                    }
                  });
                  if (!_record.security || _record.security.length === 0) {
                    _record.security = [{}];
                  }
                  props.detailAndedit(_record);
                },
              };
            }}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default TabpanelDetail;
